import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import MessageBox from 'components/MessageBox';
import DocumentTitle from 'react-document-title';
import { initialize } from 'redux-form';
import {
  getLoginStatus,
  init as initApplication,
  setProgress,
  setInitUserLocaleInStore,
  switchLocale,
} from './reducers/applicationReducer';
import {
  logout,
  fetchAllUserInfo,
  fetchUserPictureUrl,
} from './reducers/userReducer';
import {
  setMessage,
  resetMessage,
} from './reducers/messageReducer';
import { FormattedMessage } from 'react-intl';
import MessageBoxError from 'containers/App/components/MessageBox';
import MessageFormError from 'containers/App/components/MessageForm';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import vi from 'react-intl/locale-data/vi';
import * as Sentry from '@sentry/browser';
import Progress from 'components/Progress';

import 'configs/disallow';

addLocaleData([...en, ...zh, ...vi]);

class App extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    const {
      application: {
        isLoggedIn,
        locale,
      },
      history: {
        replaceState,
      },
    } = this.props;
    if (isLoggedIn) {
      this.props.fetchUserPictureUrl();
      this.props.fetchAllUserInfo().then((res) => {
        const resData = res.action.payload.data.data;
        if (process.env.PROJECT_ENV === 'production') {
          Sentry.configureScope((scope) => {
            scope.setUser({
              companyId: resData.companyId,
              companyName: resData.companyName,
              employeeId: resData.employeeId,
            });
          });
        }
        // 判斷身分驗證是否通過並導頁
        if (!resData.isVerify && window.location.pathname.indexOf('privacy') < 0) {
          replaceState(null, '/verification');
        }
        // 判斷初始選擇語系，登入語系與使用者語系不相同則更改
        if (resData.language !== locale) {
          this.props.switchLocale(locale);
        }
      });
    }
    this.props.initApplication();
  }

  renderErrorWin({ errorHttpStatus, message } = {}) {
    let text = message;
    let handler = () => {
      location.reload();
    };
    if (/401/.test(errorHttpStatus)) {
      text = message;
      handler = () => {
        this.props.history.replaceState(null, '/tube');
        location.reload();
      };
    } else if (/403/.test(errorHttpStatus)) {
      text = <FormattedMessage id="SH_PlsLoginAgain" defaultMessage="您已登出系統，請重新登入" />;
      handler = () => {
        logout(undefined, 'idleTimeout');
      };
    } else if (/404/.test(errorHttpStatus)) {
      text = <FormattedMessage id="SH_SystemErrorPlsContactTube" defaultMessage="系統無法正常執行，請聯繫APOLLO服務窗口" />;
    }

    return (
      <MessageBoxError
        width={280}
        title={<FormattedMessage id="SH_Message" defaultMessage="訊息" />}
        onClose={handler}
      >
        <MessageFormError
          onConfirm={handler}
          MessageText={text}
        />
      </MessageBoxError>
    );
  }

  render() {
    const {
      application,
      message,
      children,
    } = this.props;
    const messages = application.localeMessage;

    return (
      <IntlProvider locale={application.locale} key={application.locale} messages={messages}>
        <DocumentTitle title="Apollo - HR Management">
          <div>
          {application.isLoaded ? (
              children
            ) : (
              <div>
                {application.progresses.map((progress) => {
                  return (
                    <Progress
                      key={progress.key}
                      progress={progress.progress}
                      color={progress.color}
                    />
                  );
                })}
              </div>
            )}
            {
              (() => {
                if (/401|403|404|500/i.test(message.errorHttpStatus)) {
                  return this.renderErrorWin(message);
                }

                if (message.message && message.message.length > 0) {
                  return (
                    <MessageBox
                      title={message.title}
                      message={message.message}
                      titleColor={message.titleColor}
                      onConfirm={message.onConfirm}
                      onCancel={message.onCancel}
                      onClose={message.onClose}
                    />
                  );
                }
              })()
            }
          </div>
        </DocumentTitle>
      </IntlProvider>
    );
  }
}

App.propTypes = {
  application: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    errorHttpStatus: PropTypes.string,
  }).isRequired,
  children: PropTypes.object,
  user: PropTypes.shape({
    isLoaded: PropTypes.bool,
    isVerify: PropTypes.bool,
  }),
  message: PropTypes.object,
  setMessage: PropTypes.func,
  resetMessage: PropTypes.func,
  setProgress: PropTypes.func,
  getLoginStatus: PropTypes.func.isRequired,
  initApplication: PropTypes.func.isRequired,
  setInitUserLocaleInStore: PropTypes.func.isRequired,
  switchLocale: PropTypes.func,
  fetchAllUserInfo: PropTypes.func.isRequired,
  fetchUserPictureUrl: PropTypes.func.isRequired,
  initialize: PropTypes.func,
  putIdNumberVerify: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    application: state.app.application,
    user: state.app.user,
    message: state.app.message,
  };
}

export default connect(mapStateToProps, {
  initialize,
  setMessage,
  resetMessage,
  setProgress,
  getLoginStatus,
  initApplication,
  fetchAllUserInfo,
  fetchUserPictureUrl,
  setInitUserLocaleInStore,
  switchLocale,
})(App);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/index.js
 **/